import type { AssetDetails } from 'modules/queries/asset/useDetails';
import { acronisProductCodes } from 'utility/acronisProductMap';
import useAssetNewOrderedAddOns from './useAssetNewOrderedAddOns';

/**
 * Tells whether an Acronis backup was ordered for one server that the server's
 * backups and storage details do not list yet. `isLoading` stays true until the
 * ordered add-ons have loaded.
 */
const useAssetNewOrderedBackups = (
	asset?: Pick<
		AssetDetails,
		'uniq_id' | 'associationDetails' | 'backupsAndStorage' | 'hasAcronis'
	>,
) => {
	const { assetNewOrderedAddOns, isLoading } = useAssetNewOrderedAddOns(asset);

	return {
		isNewOrderedBackups: assetNewOrderedAddOns.some(({ code }) =>
			acronisProductCodes.includes(code),
		),
		isLoading,
	};
};

export default useAssetNewOrderedBackups;
